import script from "./RecordButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordButtons.vue?vue&type=script&setup=true&lang=js"

import "./RecordButtons.vue?vue&type=style&index=0&id=4b7569d1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b7569d1"]])

export default __exports__